import { render, staticRenderFns } from "./AyudaServicios.vue?vue&type=template&id=0276817a&scoped=true"
import script from "./AyudaServicios.vue?vue&type=script&lang=js"
export * from "./AyudaServicios.vue?vue&type=script&lang=js"
import style0 from "./AyudaServicios.vue?vue&type=style&index=0&id=0276817a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276817a",
  null
  
)

export default component.exports